import { render, staticRenderFns } from "./courseCard.vue?vue&type=template&id=70b5c6e5&scoped=true&"
import script from "./courseCard.vue?vue&type=script&lang=js&"
export * from "./courseCard.vue?vue&type=script&lang=js&"
import style0 from "./courseCard.vue?vue&type=style&index=0&id=70b5c6e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5c6e5",
  null
  
)

export default component.exports